import { SERVICE_NAMES } from '../constants';

export function getRaiseServiceLevelButtonText(serviceId: string): string {
  return `Перейти в ${SERVICE_NAMES[serviceId]}`;
}
